import axios from 'axios';

// Create a base axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request interceptor for API calls
api.interceptors.request.use(
  async (config) => {
    // Get auth token from localStorage
    const token = localStorage.getItem('authToken');
    
    // If token exists, add to headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add CSRF token if it exists
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (csrfToken) {
      config.headers['X-CSRF-Token'] = csrfToken;
    }
    
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor for API calls
api.interceptors.response.use(
  (response) => {
    // Return successful response
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Handle 401 (Unauthorized) - Token expired or invalid
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // Here you could implement token refresh logic
        // For now, just logout
        localStorage.removeItem('authToken');
        window.location.href = '/login';
        
        return Promise.reject(error);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }
    
    // Handle 403 (Forbidden)
    if (error.response && error.response.status === 403) {
      // Redirect to access denied page
      window.location.href = '/access-denied';
      return Promise.reject(error);
    }
    
    // Handle 404 (Not Found)
    if (error.response && error.response.status === 404) {
      return Promise.reject(error);
    }
    
    // Handle 500 (Server Error)
    if (error.response && error.response.status >= 500) {
      // Log to error monitoring service or handle server errors
      console.error('Server error:', error);
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);

export default api;
